import React, {useEffect, useRef, useState} from 'react';
import $api from "../http";
import "../css/user-creator.css"
import ModalDialog from "./ModalDialog";
import {useNavigate} from "react-router-dom";
import {toJS} from "mobx";
import {addDevidersToString} from "./helpers/helper-functions";

const TraderViewer = ({store}) => {


    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [processing, setProcessing] = useState({status: false, index: null})

    const [users, setUsers] = useState([])

    const [activeModal, setActiveModal] = useState("no")
    const [modalMessage, setModalMessage] = useState("")

    const [activePayoffModal, setActivePayoffModal] = useState("no")
    const [activePayoffConfirmModal, setActivePayoffConfirmModal] = useState("no")
    const [activeInfoModal, setActiveInfoModal] = useState("no")

    const [trader, setTrader] = useState()
    const [transactionHash, setTransactionHash] = useState()

    const [filter, setFilter] = useState({suspended: "active"})
    const [viewerFilter, setViewerFilter] = useState("")


    const [moneyMassMonitor, setMoneyMassMonitor] = useState({})
    const [debitors, setDebitors] = useState([])
    const [showDebitors, setShowDebitors] = useState(false)

    const usersMemo = useRef([])

    useEffect(() => {

        if(showDebitors) {
            console.log("SET USERS 1")
            setUsers(prev => {
                usersMemo.current = prev
                const newState = prev.filter(user => debitors.includes(user.id) )
                console.log(newState)
                return newState
            })
        } else {
            // getUsers(filter)
            if(usersMemo.current?.length) {
                setUsers(usersMemo.current)
            }

        }


    }, [showDebitors])


    const getUsdtPrice = async () => {
        const response = await $api.get('/get_ustd_price_admin')

        console.log(response.data)

        // setUsdtPriceBybit(response.data.usdtPriceBybit)
        // setUsdtPriceGarantex(response.data.usdtPriceGarantex)

        return {bybit: response.data.usdtPriceBybit, garantex: response.data.usdtPriceGarantex}
    }


    const buildTraderMoneyMassStatistics = async (users, viewerFilter) => {

        if (!users || users.length === 0) {

            setMoneyMassMonitor({})
            return
        }

        const currentUsdtPrices = await getUsdtPrice()


        const moneyMass = users.reduce((acc, current) => {



            if((current.login.toLowerCase().includes(viewerFilter.toLowerCase()) || viewerFilter === "") && (current.id !== "676a7d162957d4dffc8aaa25" && current.id !== "67920f012687b5af21a77c3d")) {



                const traderUsdtPrice = current.usdtPrice
                    ?
                    current.usdtPrice
                    :
                    current.usdtPriceGarantex
                        ?
                        current.usdtPriceGarantex
                        :
                        current.usdtSource === "bybit" ? currentUsdtPrices.bybit : currentUsdtPrices.garantex


                const currentMoney = (((current.balance || 0) + (current.insurance || 0)) / traderUsdtPrice) + (current.profitBalance || 0)



                console.log(`${current.login}: ${currentMoney}`)

                acc.full += currentMoney > 0 ? currentMoney : 0

                if(((current.balance / traderUsdtPrice) + current.profitBalance) < (-current.insurance / traderUsdtPrice)) {

                    console.log(current)

                    const overdraft = ((-current.insurance - current.balance) / traderUsdtPrice) - current.profitBalance;

                    acc.bad += overdraft
                    acc.debitors.push(current.id)
                }
            }





            return acc

        }, {full: 0, bad: 0, debitors: []})

        console.log(moneyMass)

        setMoneyMassMonitor(moneyMass)
        setDebitors(moneyMass.debitors)

    }





    useEffect(() => {
        if (users.length) {
            let filteredUsers = users;

            if (showDebitors) {
                filteredUsers = users.filter(user => debitors.includes(user.id));
            }

            buildTraderMoneyMassStatistics(filteredUsers, viewerFilter);
        }
    }, [users, viewerFilter, showDebitors]);








    // Состояние для отслеживания нажатой кнопки копирования
    const [copiedIndex, setCopiedIndex] = useState(null);

    const handleCopy = (traderId, index) => {
        navigator.clipboard.writeText(traderId);
        setCopiedIndex(index);
        // setTimeout(() => setCopiedIndex(null), 2000); // Возвращаем текст обратно через 2 секунды
    };

    const getUsers = async (filter) => {

        usersMemo.current = []
        setLoading(true)

        console.log(toJS(store.user.id))


        console.log(filter)

        const response = await $api.get("/get_users", {
            params: {
                filter: filter
            }
        });

        console.log(response.data)


        // Считаем сумму всех приоритетов
        // const totalPriority = response.data.reduce((sum, user) => sum + user.priority, 0);

// Добавляем каждому пользователю ключ percent
//         const middleUserState = response.data.map(user => {
//             return {
//                 ...user,
//                 percent: ((user.priority / totalPriority) * 100).toFixed(2) // Округляем до 2 знаков после запятой
//             };
//         });



        console.log("SET USERS 2")
        // setUsers(middleUserState)
        setUsers(response.data)
        setLoading(false)
    }

    const changeTraderStatus = async (userId, index) => {

        setProcessing({status: true, index})

        try {
            console.log(userId, index)
            const response = await $api.get(`/change_trader_status?userId=${userId}`)
            console.log(response.data)

            // Получаем обновленный объект карты из ответа
            const updatedUser = response.data;

            // Обновляем состояние карт
            console.log("SET USERS 3")
            setUsers(prevUsers =>
                prevUsers.map(user =>
                    user.id === updatedUser.id
                        ? { ...user, active: updatedUser.active } // Копируем все поля и меняем только поле active
                        : user
                )
            );

        } catch (e) {
            console.log(e)
        }




        setProcessing({status: false, index})

    }




    const makePayOff = async (transactionHash, traderId) => {

        try {



            const response = await $api.post('/make_payoff', {
                type: "User",
                transactionHash: transactionHash.trim(),
                agentId: traderId

            })

            if(response.data.result === "OK") {

                const freshTraderData = response.data.traderData


                console.log(freshTraderData)
                console.log("SET USERS 4")
                setUsers(prev => {
                    const newUsersState = prev.map(user => {

                        if(user.id === freshTraderData._id) {

                            user.profitBalance = freshTraderData.profitBalance
                            return user

                        } else {
                            return user
                        }
                    })

                    return newUsersState


                })

                setModalMessage(`Выплата для ${trader.login} на сумму ${response.data.amount} USDT зафиксирована`)
                setActiveInfoModal("progress")
                setTimeout(() => {
                    setActiveInfoModal("active")
                }, 100)

            } else {
                setModalMessage(response.data.message)
                setActiveInfoModal("progress")
                setTimeout(() => {
                    setActiveInfoModal("active")
                }, 100)
            }

            console.log(response.data)

        } catch (e) {
            console.log(e)

            setModalMessage(e.message)
            setActiveInfoModal("progress")
            setTimeout(() => {
                setActiveInfoModal("active")
            }, 100)

        }



    }




    useEffect(() => {
        store.setPageTitle("Трейдеры")
        if (filter?.suspended) {
            store.setPageTitle("Трейдеры");
            getUsers(filter);
        }
    }, [filter]);





    return (
        <div className={"user-viewer-wrapper"}>

            <div className={"user-viewer-active-sort-wrapper"}>

                <select
                    value={filter.suspended}
                    onChange={(e) => {

                            setShowDebitors(false)
                            setFilter(prev => {
                                return {...prev, suspended: e.target.value}
                            })


                    }}
                >
                    <option value="active">Активные</option>
                    <option value="all">Все</option>
                    <option value="suspended">Деактивированные</option>


                </select>

                <input
                    onChange={(e) => {setViewerFilter(e.target.value)}}
                    placeholder={'Поиск'}
                />

                <input
                    type={"checkbox"}
                    id={"debitors-input"}
                    checked={showDebitors}
                    onChange={(e) => {
                        setShowDebitors(prev => !prev)
                    }}
                    disabled={loading}
                />
                <label htmlFor={"debitors-input"}>Только должники</label>

                {loading
                    ?
                    <img src={require('../img/loading.gif')} height={"35px"} className={"margin-left-20"}/>
                    :
                    null
                }
            </div>
            <div className={"user-viewer-money-mass-wrapper"}>
                <h4 className={"main-admin-data-h"}>Общая масса трейдеров: {addDevidersToString(moneyMassMonitor.full?.toFixed(2))} usdt</h4>
                <h4 className={"main-admin-data-h"}>Общий долг трейдеров: {addDevidersToString(moneyMassMonitor.bad?.toFixed(2))} usdt</h4>
            </div>

            <div style={{overflowX: 'auto', width: '100%' }}>
            <table className="transaction-table">
                <thead>
                <tr>
                    <th style={{width: "1%", whiteSpace: "nowrap"}}>NickName</th>
                    <th style={{width: "1%", whiteSpace: "nowrap"}}>Баланс [₽]</th>
                    {/*<th>Страховой деп. [₽]</th>*/}
                    {store.user.admin ? <th style={{width: "1%", whiteSpace: "nowrap"}}>Профит - баланс [USDT] < /th> : null}
                    {store.user.admin ? <th style={{width: "1%", whiteSpace: "nowrap"}}>Сделки</th> : null}

                    {/*<th>ID</th>*/}
                    {store.user.admin ? <th style={{whiteSpace: "nowrap"}}>{`Ставка (%)`}</th> : null}

                    {/*<th>{`Rus от 1000 (%)`}</th>*/}
                    {/*<th>{`Trans mini (%)`}</th>*/}
                    {/*<th>{`Trans от 1000 (%)`}</th>*/}
                    {/*<th>{`NSPK mini (%)`}</th>*/}
                    {/*<th>{`NSPK от 1000 (%)`}</th>*/}

                    <th style={{width: "1%", whiteSpace: "nowrap"}}>Приоритет</th>
                    {/*<th>Получит заявок</th>*/}
                    <th style={{width: "1%", whiteSpace: "nowrap"}}>Активность</th>
                    <th style={{width: "1%", whiteSpace: "nowrap"}}>Изменение</th>
                </tr>
                </thead>
                <tbody>
                {users
                    .slice() // Создаём копию массива, чтобы не мутировать оригинал
                    .sort((a, b) => a.login.localeCompare(b.login)) // Сортируем по user.login
                    .map((user, index) => {
                        // const formattedDate = new Date(card.block_timestamp)
                        //     .toLocaleString('ru-RU', options);
                        if(!user.login.toLowerCase().includes(viewerFilter.toLowerCase())) return



                        return (
                            <tr key={user.id} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                                <td>
                                    <h4 style={{margin: "3px"}}>{user.login}</h4>
                                    <button
                                        className="copy-button"
                                        onClick={() => handleCopy(user.id, index)}
                                    >

                                        {copiedIndex === index ? 'Copied' : 'Copy ID'}
                                    </button>
                                    <h5 className={"main-admin-data-h"}>Деп: {user.insurance?.toFixed(2) || 0} р.</h5>
                                    <h5 className={"main-admin-data-h"}>Расчёты: {user.usdtSource === "garantex" ? "rapira" : user.usdtSource}</h5>
                                    <h5 className={"main-admin-data-h"}>Крупные чеки: {user.grossCheckDeny ? "❌ " : "✔️"}</h5>
                            </td>
                            {/*<td>{user.balanceOnWallet?.usdt.toFixed(2) + " / " + user.balanceOnPlatform.toFixed(2)}</td>*/}
                            <td>{user.balance?.toFixed(2)}</td>
                            {/*<td>{user.insurance?.toFixed(2)}</td>*/}
                            {store.user.admin
                                ?
                                <td>
                                <div className={"flex-table-cell-column"}>
                                    <h4 className={"main-admin-data-h"}>{addDevidersToString(user.profitBalance?.toFixed(2))}</h4>
                                    <button
                                        onClick={() => {
                                            setActivePayoffModal("progress")
                                            setTimeout(() => {
                                                setActivePayoffModal("active")
                                            }, 100)
                                            setModalMessage(`Выплата для ${user.login}`)
                                            setTrader(user)
                                        }}
                                        className={"gradient-orange-button"}
                                    >Выплата
                                    </button>
                                </div>

                                </td>
                                :
                                null
                            }
                            {store.user.admin
                                ?
                                <td>{user.orderCounter + " / " + user.allOrdersCount}</td>
                                :
                                null
                            }
                            {/*<td>{user.id}</td>*/}
                            {store.user.admin
                                ?
                                // <td className={"fixed-table-width"}>
                                //     <h5 className={"main-admin-data-h"}>{`1к - 5к | RUS | ${user.stakeMini}%`}</h5>
                                //     <h5 className={"main-admin-data-h"}>{`5к - 10к | RUS | ${user.stake}%`}</h5>
                                //     <h5 className={"main-admin-data-h"}>{`10к - ∞ | RUS | ${user.stakeMaxi}%`}</h5>
                                //     <h5 className={"main-admin-data-h"}>{`🡩 TRANS | ${user.stakeTransgran}%`}</h5>
                                //     <h5 className={"main-admin-data-h"}>{`🡫 TRANS | ${user.stakeTransgranMini}%`}</h5>
                                //     <h5 className={"main-admin-data-h"}>{`🡩 NSPK | ${user.stakeNspk}%`}</h5>
                                //     <h5 className={"main-admin-data-h"}>{`🡫 NSPK | ${user.stakeNspkMini}%`}</h5>
                                //     <h5 className={"main-admin-data-h"}>{`VTB-DIRECT | ${user.directBankStake}%`}</h5>
                                // </td>
                                <td className="fixed-table-width">
                                    {user.stakeRanges?.length > 0 ? (
                                        user.stakeRanges.map((range, index) => (
                                            <h5 key={index} className="main-admin-data-h">
                                                {`${range.min} - ${range.max} | ${range.trafficType.toUpperCase()} | ${range.value}%`}
                                            </h5>
                                        ))
                                    ) : (
                                        <>
                                            <h5 className="main-admin-data-h">{`1к - 5к | RUS | ${user.stakeMini}%`}</h5>
                                            <h5 className="main-admin-data-h">{`5к - 10к | RUS | ${user.stake}%`}</h5>
                                            <h5 className="main-admin-data-h">{`10к - ∞ | RUS | ${user.stakeMaxi}%`}</h5>
                                            <h5 className="main-admin-data-h">{`🡩 TRANS | ${user.stakeTransgran}%`}</h5>
                                            <h5 className="main-admin-data-h">{`🡫 TRANS | ${user.stakeTransgranMini}%`}</h5>
                                            <h5 className="main-admin-data-h">{`🡩 NSPK | ${user.stakeNspk}%`}</h5>
                                            <h5 className="main-admin-data-h">{`🡫 NSPK | ${user.stakeNspkMini}%`}</h5>
                                            <h5 className="main-admin-data-h">{`VTB-DIRECT | ${user.directBankStake}%`}</h5>
                                        </>
                                    )}
                                </td>
                                :
                                null
                            }


                                <td>{user.priority}</td>
                                {/*<td>{user.percent} %</td>*/}
                                <td>
                                    {user.active
                                        ?
                                        <button
                                            className={"gradient-red-button"}
                                            onClick={() => {

                                                changeTraderStatus(user.id, index)

                                            }}
                                        >Отключить
                                            {
                                                processing.status && processing.index === index
                                                    ?
                                                    <img src={require('../img/loading.gif')} height={"15px"}
                                                         className={"margin-left-20"}/>
                                                    :
                                                    null
                                            }
                                        </button>
                                        :
                                        <button
                                            className={"gradient-green-button card-status-switch-btn"}
                                            onClick={() => {

                                                changeTraderStatus(user.id, index)
                                            }}
                                        >Включить
                                            {processing.status && processing.index === index ?
                                                <img src={require('../img/loading.gif')} height={"15px"}
                                                     className={"margin-left-20"}/> : null}
                                    </button>
                                }
                            </td>

                            <td>
                                <button
                                    className={"gradient-orange-button"}
                                    onClick={() => {
                                        store.setUserToEditId(user.id)
                                        navigate('/create_user')

                                    }}
                                >Редактировать</button>
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
            </div>

            <ModalDialog
                active={activeModal}
                setActive={setActiveModal}
                // action={() => {
                //     setActiveModal("progress")
                //     setTimeout(() => {
                //         setActiveModal("no")
                //     }, 100)
                // }}
                message={modalMessage}
                purpose={"info"}
            />
            <ModalDialog
                active={activePayoffModal}
                setActive={setActivePayoffModal}
                purpose={"input"}
                inputPlaceHolder={"Хэш транзакции"}
                inputValue={transactionHash}
                setInputValue={setTransactionHash}

                message={modalMessage}
                action={() => {
                    setActivePayoffConfirmModal("progress")
                    setTimeout(() => {
                        setActivePayoffConfirmModal("active")
                    }, 100)
                    setModalMessage(`Подтверждаете выплату для ${trader.login}?`)
                }}

            />
            <ModalDialog
                active={activePayoffConfirmModal}
                setActive={setActivePayoffConfirmModal}
                purpose={"choice"}
                message={modalMessage}
                action={() => {
                    makePayOff(transactionHash, trader.id)
                }}
            />

            <ModalDialog
                purpose={"info"}
                message={modalMessage}
                active={activeInfoModal}
                setActive={setActiveInfoModal}
                buttonText2={"OK"}
            />
        </div>
    );
};

export default TraderViewer;